export const TIP_CONFIGURATION_ACTION_TYPES = {
  FETCH_TIP_CONFIGURATION_BEGIN: 'FETCH_TIP_CONFIGURATION_BEGIN',
  FETCH_TIP_CONFIGURATION_SUCCESS: 'FETCH_TIP_CONFIGURATION_SUCCESS',
  FETCH_TIP_CONFIGURATION_ERROR: 'FETCH_TIP_CONFIGURATION_ERROR',
  UPDATE_TIP_CONFIGURATION_BEGIN: 'UPDATE_TIP_CONFIGURATION_BEGIN',
  UPDATE_TIP_CONFIGURATION_SUCCESS: 'UPDATE_TIP_CONFIGURATION_SUCCESS',
  UPDATE_TIP_CONFIGURATION_ERROR: 'UPDATE_TIP_CONFIGURATION_ERROR',
};